import util from '../util'

let controller = 'PerfilFrontEnd'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetPerfilByParceiro: function (codigoParceiro) {
    return util.Axios.Get(controller + '/GetPerfilByParceiro', codigoParceiro)
  }
})
